import classNames from 'classnames';
import * as React from 'react';
import styles from '../Shared/Styles/NavButton.module.css';
import type { NavButtonProps } from '~/Partials/Nav/Components/NavButtons/NavButtons';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';

interface MyPageButtonProps extends NavButtonProps {
    myPageUrl: string;
    showMyPageTranslation: string;
}

export const MyPageButton: React.FC<React.PropsWithChildren<MyPageButtonProps>> = props => {
    const { myPageUrl, showMyPageTranslation, variant } = props;

    return (
        <a href={myPageUrl} className={classNames(styles.ButtonIcon, variant && styles[`Variant--${variant}`])}>
            <span className="visuallyHidden">{showMyPageTranslation}</span>
            <SvgIcon iconName="user" />
        </a>
    );
};
